function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import format from 'date-fns/format';
import compareAsc from 'date-fns/compareAsc';
import compareDesc from 'date-fns/compareDesc';
import eachDay from 'date-fns/eachDayOfInterval';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import addWeeks from 'date-fns/addWeeks';
import addYears from 'date-fns/addYears';
import getDayOfYear from 'date-fns/getDayOfYear';
import getTime from 'date-fns/getTime';
import parseISO from 'date-fns/parseISO';
import isDate from 'date-fns/isDate';
import addMonths from 'date-fns/addMonths';
import addDays from 'date-fns/addDays';
import addHours from 'date-fns/addHours';
import addMinutes from 'date-fns/addMinutes';
import addSeconds from 'date-fns/addSeconds';
import isValid from 'date-fns/isValid';
import formatToTimeZone from 'date-fns-tz/format';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
export var DEFAULT_DATEFORMAT = 'yyyy-MM-dd';
export var DEFAULT_TIMEZONE = 'America/New_York';
export var DATETIME_FORMATS = {
  mediumMonth: 'MMM',
  longMonth: 'MMMM',
  longYear: 'yyyy',
  shortMonthDay: 'M/dd',
  mediumMonthDay: 'MM/dd',
  longMonthDay: 'MMM d',
  mediumMonthYear: 'MMM yyyy',
  longMonthYear: 'MMMM yyyy',
  tinyMonthDayYear: 'M/dd/yyyy',
  shortMonthDayYear: 'MM/dd/yyyy',
  mediumMonthDayYear: 'MMM d, yyyy',
  longMonthDayYear: 'MMMM d, yyyy',
  shortMonthDayYearTime: 'MM/dd/yyyy h:mm a z',
  mediumMonthDayYearTime: 'MMM d, yyyy h:mm a z',
  longMonthDayYearTime: 'MMMM do, yyyy, h:mm a z',
  monthDayHour: 'MMMM d, h a',
  time: 'h:mm a',
  hour: 'h a'
};
export var isValidDefaultFormat = function isValidDefaultFormat(d) {
  return /^\d{4}-(0[1-9]|1[012])-(0[1-9]|1[0-9]|2[0-9]|3[01])$/.test(d);
};

// This validation will only work for javascript Date objects and strings in
// the format 'yyyy-MM-dd'
export var isValidDate = function isValidDate(d) {
  if (d) {
    if (isDate(d) && isValid(d)) {
      return true;
    }
    if (isValidDefaultFormat(d)) {
      var dateParts = d.split('-');
      var day = Number(dateParts[2]);
      var month = Number(dateParts[1]) - 1; // 0-indexed month
      var year = Number(dateParts[0]);
      // We make this comparison to account for how javascript will gleefully
      // convert 2019-02-30 into March 1, 2019.
      var compareDate = new Date(year, month, day);
      var yearMatches = compareDate.getFullYear() === year;
      var monthMatches = compareDate.getMonth() === month;
      var dayMatches = compareDate.getDate() === day;
      return yearMatches && monthMatches && dayMatches;
    }
    return false;
  }
  return false;
};

// DO NOT USE IF TIME NEEDS TO BE PROPOGATED OR MATTERS IN A COMPARISON
export var parse = function parse(d) {
  return d && !isDate(d) ? parseISO(d.split('T')[0]) : d;
};

// USE THIS IF TIME SHOULD BE PROPOGATED AND MATTERS IN A COMPARISON
export var parseDateTime = function parseDateTime(dateTime) {
  return dateTime && !isDate(dateTime) ? parseISO(dateTime) : dateTime;
};
export var formatDate = function formatDate(date) {
  var formatter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATEFORMAT;
  var parsedDate = date ? parse(date) : null;
  return isValid(parsedDate) ? format(parsedDate, formatter) : null;
};
export var formatDateTime = function formatDateTime(date) {
  var formatString = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DATETIME_FORMATS.longMonthDayYearTime;
  var timeZone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'America/New_York';
  var parsedDate = date ? utcToZonedTime(date, timeZone) : null;
  return isValid(parsedDate) ? formatToTimeZone(parsedDate, formatString, {
    timeZone: timeZone
  }) : null;
};
export var getStartOfWeek = function getStartOfWeek(date) {
  return startOfWeek(parse(date));
};
export var getEndOfWeek = function getEndOfWeek(date) {
  return endOfWeek(parse(date));
};
export var getYearInDays = function getYearInDays(start, end) {
  return eachDay({
    start: getStartOfWeek(start),
    end: getEndOfWeek(end)
  });
};
export var getYearInWeeks = function getYearInWeeks(start, end) {
  var daysOfYear = getYearInDays(start, end);
  return daysOfYear.reduce(function (acc, d, i) {
    return i % 7 === 0 ? [].concat(_toConsumableArray(acc), [{
      startDate: d,
      endDate: daysOfYear[i + 6]
    }]) : acc;
  }, []);
};
export var addWeeksToRange = function addWeeksToRange(endDate, numOfWeeks) {
  return addWeeks(parse(endDate), numOfWeeks);
};

// sorts object with attribute date
export var sortDates = function sortDates(dates) {
  var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'date';
  var dir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'asc';
  return dates.sort(function (a, b) {
    return dir === 'asc' ? compareAsc(parse(a[key]), parse(b[key])) : compareDesc(parse(a[key]), parse(b[key]));
  });
};
export var getDayNumberInYear = function getDayNumberInYear(d) {
  return getDayOfYear(parse(d));
};
export var educationPeriodDateSpread = function educationPeriodDateSpread(start, end) {
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '/';
  return "".concat(formatDate(start, 'yyyy')).concat(separator).concat(formatDate(end, 'yy'));
};
export var getTimeInMilliseconds = function getTimeInMilliseconds(d) {
  var date = d && !isDate(d) ? parseISO(d) : d;
  return getTime(date);
};

// use negative number to go backwards
export var manipulateYear = function manipulateYear(d, years) {
  return addYears(parse(d), years);
};
export var manipulateMonths = function manipulateMonths(d, months) {
  return addMonths(parse(d), months);
};
export var manipulateDays = function manipulateDays(d, days) {
  return addDays(parse(d), days);
};
export var manipulateHours = function manipulateHours(d, hours) {
  return addHours(parseDateTime(d), hours);
};
export var manipulateMinutes = function manipulateMinutes(d, mins) {
  return addMinutes(parseDateTime(d), mins);
};
export var manipulateSeconds = function manipulateSeconds(d, secs) {
  return addSeconds(parseDateTime(d), secs);
};